import axios from 'axios';
import { useAuthContext } from 'src/auth/hooks';
// config
import { HOST_API } from 'src/config-global';
// import axiosInstance, { endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API, withCredentials: true });
let idToPass;
axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------
export const setID = (id) => {
  let valToReturn = false;
  if (idToPass !== undefined) {
    idToPass = id;
    valToReturn = true;
  }
  return valToReturn;
};

export const fetcher = async (id) => {
  const generalFormation = {};

  try {
    const response = await axiosInstance.get(`${endpoints.formations.getAllSession}/${id}`);
    // console.log('response', response);
    response.data.data.forEach((formation) => {
      const defautKanbanObject = {
        id: String(formation.session_id),
        due: [null, null],
        status: formation.planning,
        labels: [],
        comments: [],
        assignee: [
          {
            id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1',
            name: 'Jayvion Simon',
            avatarUrl: 'https://api-dev-minimal-v510.vercel.app/assets/images/avatar/avatar_1.jpg',
          },
          {
            id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2',
            name: 'Lucian Obrien',
            avatarUrl: 'https://api-dev-minimal-v510.vercel.app/assets/images/avatar/avatar_2.jpg',
          },
          {
            id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3',
            name: 'Deja Brady',
            avatarUrl: 'https://api-dev-minimal-v510.vercel.app/assets/images/avatar/avatar_3.jpg',
          },
        ],
        priority: 'low',
        attachments: [],
        reporter: {
          id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b17',
          name: 'Angelique Morse',
          avatarUrl: 'https://api-dev-minimal-v510.vercel.app/assets/images/avatar/avatar_17.jpg',
        },
        name: 'Complete Project Proposal',
        description: 'Occaecati est et illo quibusdam accusamus qui. Incidunt aut et molestiae ut facere aut. Est quidem iusto praesentium excepturi harum nihil tenetur facilis. Ut omnis voluptates nihil accusantium doloribus eaque debitis.',
      };

      const mergedFormation = { ...formation, ...defautKanbanObject }; // Fusionne task avec additionalData

      // console.log( 'element retourner transformer', mergedFormation );
      generalFormation[formation.session_id] = mergedFormation;
    });

    const ended = [];
    const planned = [];
    const pending = [];

    Object.keys(generalFormation).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(generalFormation, key)) {
        const session = generalFormation[key];
        if (session.status === 'ended') {
          ended.push(session.id);
        } else if (session.status === 'planned') {
          planned.push(session.id);
        } else if (session.status === 'pending') {
          pending.push(session.id);
        }
        // console.log(`ID: ${session.id}, Status: ${session.status}`);
      }
    });

    const dataCreated = {
      board: {
        columns: {
          '1-column-e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1': {
            id: '1-column-e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1',
            name: 'EN ATTENTE',
            taskIds: pending,
          },
          '2-column-e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2': {
            id: '2-column-e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2',
            name: 'PLANIFIÉES',
            taskIds: planned,
          },
          '3-column-e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3': {
            id: '3-column-e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3',
            name: 'TERMINÉES',
            taskIds: ended,
          },
        },
        tasks: generalFormation,
        ordered: ['1-column-e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1', '2-column-e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2', '3-column-e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3'],
      },
    };
    // console.log('element retourner', dataCreated);
    // console.log( 'element retourner transformer', data );
    return dataCreated;
  } catch (error) {
    console.error('Erreur lors de la requête :', error);
    return error;
  }
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/auth/me',
    login: '/api/auth/login',
    register: '/api/auth/register',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
  signature: {
    save: '/api/signatures/save',
    update: '/api/signatures/update',
    delete: '/api/signatures/delete',
    getUnique: '/api/signatures',
    getAll: '/api/signatures/users',
  },
  trainee: {
    getAll: '/api/users',
    delete: '/api/users/delete/trainee',
  },
  contributor: {
    getAll: '/api/users',
    delete: '/api/users/delete/contributor',
  },
  user: {
    get: '/api/users',
    addUser: '/api/users/save',
    addUserProfil: '/api/users/profile/save',
    updatePassword: '/api/users/password/change',
    uploadImage: '/api/images/upload',
  },
  formations: {
    getAll: '/api/sessions/organizations',
    getAllSession: '/api/plannings/users',
    reservationsList: '/api/reservations/sessions',
    ChangeStatut: '/api/reservations/trainees/update',
  },
};
